"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTHENTICATING = exports.AUTHENTICATING = "AUTHENTICATING";
var AUTHENTICATED = exports.AUTHENTICATED = "AUTHENTICATED";
var AUTHENTICATION_FAILED = exports.AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";
var LOGOUT = exports.LOGOUT = "LOGOUT";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-redux/auth/actionTypes.js
// module id = ../lib/egov-ui-framework/ui-redux/auth/actionTypes.js
// module chunks = 504